import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
} from "@mui/material";



const CustomTextField = ({
  value,
  onChange,
  placeholder,
  error,
  helperText,
  disabled
}) => (
  <Box sx={{ marginLeft: "1rem" }}>
    <TextField
      fullWidth
      multiline
      placeholder={placeholder || "Enter Text"}
      value={value}
      onChange={onChange}
      disabled={disabled}
      sx={{
        "& .MuiOutlinedInput-root": { padding: "0.6rem" },
        marginTop: "-0.5rem",
      }}
      error={error} // Shows the error state
      helperText={
        <Typography
          variant="body2"
          color="error"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
            marginLeft: "-10px",
          }}
        >
          {helperText}
        </Typography>
      }
    />
  </Box>
);

export default CustomTextField;